module.exports = __webpack_public_path__ + "static/media/Tribe_bg.9e97353c.png";